<template>
  <div class="table-indicator-item compare" @mouseenter="percentAnimOver = true" @mouseleave="percentAnimOver = false">
    <div class="bar" :class="[barColor]">
      <div class="percent" :style="{ width: average + '%' }" :class="[color]"/>
      <div class="amount"><span :style="{ opacity: amount ? 1 : 0}">{{ amount | formatNum }}</span><span :style="{ opacity: restAmount ? 1 : 0}">{{ restAmount | formatNum }}</span></div>
      <div class="percent anim" :style="{ width: percentAnimOver ? average + '%' : 0 }" :class="[color]"/>
      <div class="amount anim"><span :style="{ opacity: average ? 1 : 0}">{{ formatttedAverage + '% realizadas' }}</span><span :style="{ opacity: restAverage ? 1 : 0}">{{ formatttedRestAverage + '% pendientes' }}</span></div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component({
  filters: {
    formatNum (value: number) {
      return value.toLocaleString('en')
    }
  }
})
export default class TableKpiCompareItem extends Vue {
  @Prop({ required: true, default: 0 })
  amount: number

  @Prop({ required: true, default: 0 })
  total: number

  @Prop({ required: false, default: 'yellow' })
  barColor: string

  @Prop({ required: false, default: 'blue' })
  color: string

  average = 0
  restAverage = 0
  restAmount = 0
  percentAnimOver = false;

  mounted () {
    this.calc()
  }

  calc () {
    this.average = this.amount / this.total * 100
    this.restAverage = 100 - this.average
    this.restAmount = this.total - this.amount
  }

  get formatttedAverage () {
    return this.average.toFixed(1)
  }

  get formatttedRestAverage () {
    return this.restAverage.toFixed(1)
  }

  @Watch('total')
  watchTotal () {
    this.calc()
  }

  @Watch('amount')
  watchAmount () {
    this.calc()
  }
}
</script>
